module.exports = __webpack_public_path__ + "static/media/lvl2.59e7a951.png";